import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputText } from 'primereact/inputtext';
import { CustomerService } from '../service/CustomerService';
import { Button } from 'primereact/button';
import { useHistory } from "react-router-dom";
import { Dialog } from 'primereact/dialog';
import { Toast } from 'primereact/toast';
import React from 'react';

export const UsersPage = () => {

    let emptyUser = {
        id: null,
        name: '',
        image: null,
        description: '',
        category: null,
        price: 0,
        quantity: 0,
        rating: 0,
        inventoryStatus: 'INSTOCK'
    };
    
    const [users, setUsers] = React.useState(null);
    const [globalFilter, setGlobalFilter] = React.useState('');
    const [loading, setLoading] = React.useState(true);
    const [user, setUser] = React.useState(emptyUser);
    const [page, setPage] = React.useState(1);
    const [size, setSize] = React.useState(100);
    const [deleteUserDialog, setDeleteUserDialog] = React.useState(false);
    
    const toast = React.useRef(null);

    let history = useHistory();

    React.useEffect(() => {

        const requestPayload = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*' ,
                'Authorization': 'Bearer ' +localStorage.getItem('jwt')
            },
            body: JSON.stringify({
                page: page,
                size: size,
                keyword: ""
            })
        }

        fetch('https://springboot-widy-app.widyan123.site/widy-app/users/paging', requestPayload)
        .then(res => {
            if(res.status >= 400 && res.status <= 599) {
                console.log('HTTP ', res.status);
                return Promise.reject(res);
            } else {
                console.log('HTTP ', res.status);
                return Promise.resolve(res);
            } 
        })
        .then(res => res.json())
        .then(res => {
            setUsers(res.data);
            console.log("users", users);
            setLoading(false);
        })
        .catch(res => {
            console.log("catch ", res);
            if(res.status === 401) {
                history.push('/login');
            } else {
                console.log("catch: ", res);
                setLoading(false);
            }            
        }); 
    }, []);

    const openEdit = (rowData) => {
        history.push({
            pathname: '/user',
            state: {
                todo: 'Ubah',
                dataUser: rowData
            }
        });
    }
    console.log("users",users);

    const confirmDeleteUser = (user) => {
        setUser(user);
        setDeleteUserDialog(true);
    }

    const userTableHeader = (
        <div className="table-header">
            List of Users
            <span className="p-input-icon-left">
                <i className="pi pi-search" />
                <InputText value={globalFilter} onChange={(e) => setGlobalFilter(e.target.value)} placeholder="Global Search" />
            </span>
        </div>
    );

    const bodyTemplate = (data, props) => {
        return (
            <>
                <span className="p-column-title">{props.header}</span>
                {data[props.field]}
            </>
        );
    };

    const userRoleBodyTemplate = (rowData) => {
        let userRole = "";
        rowData.roles.forEach(function(e) {
            userRole += e.name + ", "
        })        
        userRole = userRole.substring(0, userRole.length - 2);
        
        return (
            <>
            <span className='p-column-title'>User Role</span>
            {userRole}
            </>
        )
    }

    const userBlockedBodyTemplate = (rowData) => {
        return (
            <>
            <span className='p-column-title'>Blocked</span>
            {rowData.isBlocked === true ? "Ya" : "Tidak"}
            </>
        )
    }

    const userVerifiedBodyTemplate = (rowData) => {
        return (
            <>
            <span className='p-column-title'>Verified</span>
            {rowData.isVerified === true ? "Terverifikasi" : "Belum di Verifikasi"}
            </>
        )
    }

    const actionBodyTemplate = (rowData) => {
        return (
            <div className="actions">
                <Button icon="pi pi-pencil" className="p-button-rounded p-button-success mr-2" onClick={() => openEdit(rowData)} />
                <Button icon="pi pi-trash" className="p-button-rounded p-button-warning" onClick={() => confirmDeleteUser(rowData)} />
            </div>
        );
    }

    const hideDeleteUserDialog = () => {
        setDeleteUserDialog(false);
    }

    async function deleteUserBackEnd(user) {
        const requestPayload = {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*' ,
                'Authorization': 'Bearer ' +localStorage.getItem('jwt')
            }

        }         
          
        const response = await fetch(`https://springboot-widy-app.widyan123.site/widy-app/users/delete/${user.id}`, requestPayload);        
        const res = await response.json();
        console.log('response', res);
        if(response.status >= 200 && response.status <= 299) {
            toast.current.show({ severity: 'success', summary: 'Successful', detail: res.message, life: 3000 });
        } else if(response.status >= 400 && response.status <= 499) {
            toast.current.show({ severity: 'error', summary: 'Failed', detail: res.message, life: 3000 });
        } else {
            toast.current.show({ severity: 'error', summary: 'Error', detail: res.message, life: 3000 });
        }
    }

    const deleteUser = () => {
        let _users = users.filter(val => val.id !== user.id);
        setUsers(_users);
        setDeleteUserDialog(false);
        setUser(emptyUser);
        deleteUserBackEnd(user);
    }

    const deleteUserDialogFooter = (
        <>
            <Button label="No" icon="pi pi-times" className="p-button-text" onClick={hideDeleteUserDialog} />
            <Button label="Yes" icon="pi pi-check" className="p-button-text" onClick={deleteUser} />
        </>
    );

    return (
        <div className="grid table-demo">
            <div className="col-12">
                <div className="card">
                    <Toast ref={toast} />            
                    <DataTable value={users} paginator className="p-datatable-customers" rows={7} dataKey="id" rowHover
                        globalFilter={globalFilter} emptyMessage="No User found." loading={loading} header={userTableHeader}>
                        <Column field="name" header="Name" sortable body={bodyTemplate}></Column>
                        <Column field="username" header="Username" sortable body={bodyTemplate}></Column>
                        <Column field="status" header="User Role" sortable body={userRoleBodyTemplate}></Column>
                        <Column field="isBlocked" header="Blocked" sortable body={userBlockedBodyTemplate}></Column>
                        <Column field="isVerified" header="Verified" sortable body={userVerifiedBodyTemplate}></Column>
                        <Column header="Action" body={actionBodyTemplate}></Column>
                    </DataTable>

                    <Dialog visible={deleteUserDialog} style={{ width: '450px' }} header="Confirm" modal footer={deleteUserDialogFooter} onHide={hideDeleteUserDialog}>
                        <div className="flex align-items-center justify-content-center">
                            <i className="pi pi-exclamation-triangle mr-3" style={{ fontSize: '2rem' }} />
                            {user && <span>Are you sure you want to delete <b>{user.name}</b>?</span>}
                        </div>
                    </Dialog>
                </div>
            </div>
        </div>
    )
}
